<p-toast></p-toast>

<div style="padding-top: 4px">
    <p-toast key="message"></p-toast>
    <p-steps
        [model]="items"
        [readonly]="true"
        [activeIndex]="activeIndex"
        (activeIndexChange)="onActiveIndexChange($event)"
    ></p-steps>
</div>
<br />
<ng-container *ngIf="activeIndex === 0">
    <div>
        <div class="filter-container">
            <div class="filter-row-2 flex align-items-end gap-3">
                <!-- Select All Checkbox -->
                <div class="search-container">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input
                            type="text"
                            pInputText
                            id="studentSearch"
                            class="search-input"
                            placeholder="Search Students"
                            (input)="filter()"
                            [(ngModel)]="studentSearchInput"
                            appCapitalizeFirstLetter
                            appNoLeadingSpace
                            #studentSearch
                        />
                    </span>
                </div>
                <!-- Select Tag Dropdown -->
                <p-dropdown
                    appendTo="body"
                    class="custom-dropdown-filter mr-2"
                    optionLabel="name"
                    [(ngModel)]="selectedRoomId"
                    filterBy="name"
                    [options]="roomList"
                    optionValue="id"
                    [filter]="true"
                    [placeholder]="'Select Classroom'"
                    (onChange)="filterRoom()"
                    #roomNameDropdown
                >
                </p-dropdown>
                <!-- Select Tag Dropdown -->
                <p-multiSelect
                    appendTo="body"
                    class="custom-dropdown-filter mr-2"
                    optionLabel="name"
                    [(ngModel)]="selectedTagId"
                    filterBy="name"
                    [options]="tagList"
                    optionValue="id"
                    [filter]="true"
                    placeholder="Select Tag"
                    (onChange)="filterTag()"
                    #tagNameDropdown
                >
                </p-multiSelect>
                <!-- Select Status Dropdown -->
                <!-- <input pInputText id="date" class="border-gainsboro" [(ngModel)]="selectedDate"
                    (ngModelChange)="queryData()" placeholder="Date" type="date" /> -->

                <button
                    pButton
                    type="button"
                    label="Clear All"
                    (click)="onClear()"
                    class="clear-btn"
                ></button>
            </div>

            <div class="filter-row-3 flex align-items-end gap-3">
                <!-- <div class="student-profile-page__note--box">
                    <p class="p-2">Students will be refreshed on basis of date selection.Please select Date first.</p>
                </div> -->
            </div>
            <div class="filter-row-4 flex align-items-end gap-3">
                <div class="flex align-items-end gap-2">
                    <p-checkbox
                        [binary]="true"
                        [(ngModel)]="selectAllStudents"
                        (onChange)="toggleAllSelection(); checkboxChanged()"
                    ></p-checkbox>
                    <label for="selectAll" class="mb-0">Select All</label>
                </div>
            </div>
        </div>
        <p-dataView [value]="studentList">
            <ng-template let-student pTemplate="listItem">
                <div
                    class="student-item"
                    [ngClass]="{ 'selected-student': student.selected }"
                >
                    <img
                    *ngIf="student.profileimg; else noImageFound"
                    [src]="student.profileimg"
                    alt="Student Photo"
                    class="student-photo"
                />
                    <ng-template #noImageFound>
                                <div class="circle flex justify-content-center align-items-center mr-1 flex-shrink-0"
                                    [style.background-color]="getBackgroundColor(student.id)" >
                                    {{ getInitials(student.studentName) }}
                                </div>
                    </ng-template>
                    <span class="student-name text-primary">{{
                        student.studentName
                    }}</span>
                    <p-checkbox
                        [binary]="true"
                        [(ngModel)]="student.selected"
                        [value]="student"
                        (onChange)="
                            toggleSelection(student);
                            isSelected(student);
                            checkboxChanged()
                        "
                    >
                    </p-checkbox>
                </div>
            </ng-template>
            <ng-template pTemplate="empty">
                <div class="row" style="justify-content: center">
                    <span class="text-primary text-center">
                        No result found
                    </span>
                </div>
            </ng-template>
            <ng-template pTemplate="footer">
                <div
                    class="flex align-items-center justify-content-center gap-3"
                >
                    <button
                        pButton
                        pRipple
                        type="button"
                        label="Cancel"
                        class="p-button-outlined"
                        (click)="ref.close()"
                    ></button>
                    <button
                        pButton
                        pRipple
                        label="Continue"
                        id="save"
                        (click)="complete()"
                    ></button>
                </div>
            </ng-template>
        </p-dataView>
    </div>
</ng-container>

<ng-container *ngIf="activeIndex === 1">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="selected-students-container">
                    <div
                        class="student-card"
                        *ngFor="let student of selectedStudentList"
                    >
                        <img
                            *ngIf="student.profileimg; else noImageFound"
                            [src]="student.profileimg"
                            alt="Student Photo"
                            class="student-photo"
                        />
                        <ng-template #noImageFound>
                            <div
                                class="circle flex justify-content-center align-items-center mr-1 flex-shrink-0"
                                [style.background-color]="
                                    getBackgroundColor(student.id)
                                "
                            >
                                {{ getInitials(student.studentName) }}
                            </div>
                        </ng-template>

                        <!-- Student Name -->
                        <span class="student-name align-items-left">{{
                            student.studentName
                        }}</span>

                        <!-- Delete Icon -->
                        <button
                            class="delete-btn"
                            (click)="onRemoveStud($event, student)"
                        >
                            <i class="pi pi-trash"></i>
                            <p-confirmPopup key="confirm2"></p-confirmPopup>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid p-fluid mb-2 row">
        <div class="col-sm-3">
            <label htmlFor="Date" class="label">Date</label>
            <input
                pInputText
                id="date"
                [readonly]="true"
                [(ngModel)]="selectedDate"
                (ngModelChange)="handleDateChange($event)"
                placeholder="Date"
                type="date"
            />
        </div>
        <div class="col-sm-3">
            <label htmlFor="Time" class="label">Time</label>
            <input
                pInputText
                id="time"
                type="time"
                [(ngModel)]="signOutTime"
                pInputText
            />
        </div>
        <div class="col-sm-4">
            <label htmlFor="classroom" class="label" [appAsterisk]="true"
                >Transfer to Classroom</label
            >
            <p-dropdown
                appendTo="body"
                class="custom-dropdown-filter ml-2"
                optionLabel="name"
                *authorityShow="['Attendance Daily (Full Access)']"
                [(ngModel)]="selectedRoom"
                filterBy="name"
                [options]="filteredRoomList"
                optionValue="id"
                (onFilter)="filterRoom()"
                [filter]="true"
                [placeholder]="'Select Classroom'"
                #roomNameDropdown
            >
            </p-dropdown>
        </div>
    </div>
    <div class="flex align-items-center justify-content-center gap-3">
        <button
            pButton
            pRipple
            type="button"
            label="Back"
            class="p-button-outlined"
            [disabled]="fromOverView"
            (click)="prevPage()"
        ></button>
        <button
            pButton
            pRipple
            label="Save"
            id="save"
            [disabled]="
                !selectedRoom || !selectedStudentList!.length || buttonDisabled
            "
            (click)="onSave()"
        ></button>
    </div>
</ng-container>
